<template>
  <v-app>
    <v-overlay :value="!$store.get('app/ready')" opacity="1" z-index="99">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <AppBar v-if="$route.name !== 'Login'" />
    <v-dialog :value="$store.get('app/showErrorModal')" width="600" persistent>
      <ErrorModal v-if="$store.get('app/showErrorModal')" />
    </v-dialog>
    <v-main>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from './components/AppBar'
import ErrorModal from './components/ErrorModal'

export default {
  name: 'App',

  components: {
    AppBar,
    ErrorModal
  }
}
</script>
